import React, { useState, useEffect, useRef } from 'react';
import Header from '../Common_Files/Header';
import Footer from '../Common_Files/Footer';
import config from '../Common_Files/Config';
import generatePDF, { generateProformaPDFBlob } from './Proforma';
import generateDeliveryNotePDF from './DeliveryNote';
import generateCollectionNotePDF from './CollectionNotePdf';
import axios from 'axios';
import 'datatables.net-bs5/css/dataTables.bootstrap5.min.css';
import 'datatables.net-bs5';
import { DateRangePicker } from 'rsuite';
import { format } from 'date-fns';
import Select from 'react-select';
import Swal from 'sweetalert2';

import ViewCustomer from "../Master/ViewCustomer";
import { createInvoiceClick, isSalesDeleteClick } from '../../services/CurrentSalesOrderService';
import { fetchCustomerData } from '../../services/NewSalesService';
import { fetchUsers } from '../../services/userService';


const CurrentSalesOrder = () => {
  const [fromDate, setFromDate] = useState('');
  const [toDate, setToDate] = useState('');
  const [searchValue, setSearchValue] = useState('');
  const [customerData, setCustomerData] = useState([]);
  const [orderId, setOrderId] = useState(0);
  const [newSales, setNewSales] = useState([]);
  const [notes, setNotes] = useState(200);
  const [grossTotal, setGrossTotal] = useState(0);
  const [createInvoiceData, setCreateInvoiceData] = useState([]);
  const [productBatch, setProductBatch] = useState([]);
  const accessToken = localStorage.getItem('accessToken');
  const createInvoiceModalRef = useRef(null);
  const isSalesDeleteModalRef = useRef(null);
  const changeCustomerModalRef = useRef(null);
  const [salesInfoData, setSalesInfoData] = useState([]);
  const [groupedBatches, setGroupedBatches] = useState({}); // Initialize as empty object
  const [selectedBatchIds, setSelectedBatchIds] = useState({});
  const [productSO, setProductSO] = useState([]);
  const [pastInvoiceHeader, setPastInvoiceHeader] = useState({ product_desc: '', code: '' });
  // Email popup state variables
  const [showEmailPopup, setShowEmailPopup] = useState(false);
  const [selectedOrderId, setSelectedOrderId] = useState(null);
  const [systemUsers, setSystemUsers] = useState([]);
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [emailSubject, setEmailSubject] = useState('Proforma Invoice');
  const emailModalRef = useRef(null);

  //const apiUrl = `${config.api_url}/get-sales-list`;


  const apiUrl = `${config.api_url}/get-sales-listNew`;
  const handleGeneratePDF = (e, id) => {
    generatePDF(id);
  }

  const handlegenerateDeliveryNotePDF = (e, id) => {
    generateDeliveryNotePDF(id);
  }

  const handleGenerateCollectionNotePDF = (e, id) => {
    generateCollectionNotePDF(id);
  }

  const handleBatchChange = (event, batchCode, batchId) => {
    const isChecked = event.target.checked;

    setSelectedBatchIds(prevSelectedBatchIds => {
      const currentSelections = prevSelectedBatchIds[batchCode] || [];

      if (isChecked) {
        // Add the batch ID if checked
        return {
          ...prevSelectedBatchIds,
          [batchCode]: [...currentSelections, batchId]
        };
      } else {
        // Remove the batch ID if unchecked
        return {
          ...prevSelectedBatchIds,
          [batchCode]: currentSelections.filter(id => id !== batchId)
        };
      }
    });
  };

  const handleTransportChange = async (saleId, isChecked) => {
    const isTransport = isChecked ? 1 : 0;

    try {
      const formData = new FormData();
      formData.append('sale_id', saleId);
      formData.append('is_transport', isTransport);

      const response = await axios.post(`${config.api_url}/update-transport-status`, formData, {
        headers: {
          'Authorization': `Bearer ${accessToken}`,
        },
      });

      if (response.data.status === 'success') {
        setNewSales(prevSales =>
          prevSales.map(item =>
            item.ids === saleId ? { ...item, is_transport: isTransport } : item
          )
        );
      } else {
        Swal.fire({
          title: "Error!",
          text: "Failed to update transport status.",
          icon: "error",
          timer: 1500,
          showConfirmButton: false,
        });
      }
    } catch (error) {
      console.error("Failed to update transport status:", error);
      Swal.fire({
        title: "Error!",
        text: "Failed to update transport status. Please try again.",
        icon: "error",
        timer: 1500,
        showConfirmButton: false,
      });
    }
  };

  const submitDeleteSO = async (id, notes) => {

    const formData = new FormData();
    formData.append('sales_id', id);
    formData.append('notes', notes);
    const apiUrl = `${config.api_url}/ws-update-sale-order-delete`;
    try {
      const response = await axios.post(apiUrl, formData, {
        headers: {
          'Authorization': `Bearer ${accessToken}`
        },
      });

      const data = await response.data;

      if (data.status === "success") {
        setNewSales(prevSales => prevSales.filter(item => item.ids !== id));
        
        if (isSalesDeleteModalRef.current) {
          const bsModal = window.bootstrap.Modal.getInstance(isSalesDeleteModalRef.current);
          if (bsModal) bsModal.hide();
        }

        Swal.fire({
          title: "Success!",
          text: "Order Deleted Successfully.",
          icon: "success",
          timer: 1500,
          showConfirmButton: false,
        });

        await fetchData();
      } else {
        Swal.fire({
          title: "Error!",
          text: data.message || "Failed to delete order.",
          icon: "error",
          timer: 1500,
          showConfirmButton: false,
        });
      }
    }
    catch (error) {
      console.error("Failed to delete order:", error);
      Swal.fire({
        title: "Error!",
        text: "Failed to delete order. Please try again.",
        icon: "error",
        timer: 1500,
        showConfirmButton: false,
      });
    }

  }

  const submitCreateInvoice = async (id, notes, newSales, setNewSales) => {
    let status = 'Delivered';
    const formData = new FormData();
    formData.append('status', status);
    formData.append('order_id', id);
    formData.append('notes', notes);
    const apiUrl = `${config.api_url}/ws-update-sale-status`;

    try {
      const response = await axios.post(apiUrl, formData, {
        headers: {
          'Authorization': `Bearer ${accessToken}`
        },
      });

      if (response.data.status === 'success') {
        // Show success message
        Swal.fire({
          title: "Success!",
          text: "Invoice created successfully.",
          icon: "success",
          timer: 1500,
          showConfirmButton: false,
        });

        // Refresh the data from server to get updated information
        await fetchData();

        // Close the modal
        if (createInvoiceModalRef.current) {
          const bsModal = window.bootstrap.Modal.getInstance(createInvoiceModalRef.current);
          if (bsModal) bsModal.hide();
        }
      } else {
        // Handle error case
        Swal.fire({
          title: "Error!",
          text: "Failed to create invoice.",
          icon: "error",
        });
      }
    } catch (error) {
      console.error("Failed to update status:", error);
      Swal.fire({
        title: "Error!",
        text: "Failed to create invoice. Please try again.",
        icon: "error",
      });
    }
  }

  const convertToSO = async (id, notes, newSales, setNewSales) => {
    let status = 'SO';
    const formData = new FormData();
    formData.append('status', status);
    formData.append('order_id', id);
    formData.append('notes', notes);
    const apiUrl = `${config.api_url}/ws-update-sale-status`;
    try {
      const response = await axios.post(apiUrl, formData, {
        headers: {
          'Authorization': `Bearer ${accessToken}`
        },
      });

      if (response.data.status === 'success') {
        var updatedSales = newSales.map(item =>
          item.ids === id ? { ...item, status: 'SO' } : item
        );
      }

      // window.location.reload();
      setNewSales(updatedSales);

      if (createInvoiceModalRef.current) {
        const bsModal = window.bootstrap.Modal.getInstance(createInvoiceModalRef.current);
        if (bsModal) bsModal.hide();
      }
    }
    catch (error) {
      console.error("Failed to update status:", error);
    }

  }

  const fetchData = async () => {
    const formData = new FormData();
    formData.append('searchByFromdate', fromDate || '');
    formData.append('searchByTodate', toDate || '');
    formData.append('searchValue', searchValue || '');
    formData.append('draw', '1');
    formData.append('start', '0');
    formData.append('length', '10000'); // Large number to get all records

    // Debug: Log FormData contents
    console.log('Sending request with:', {
      searchByFromdate: fromDate,
      searchByTodate: toDate,
      searchValue: searchValue,
      draw: '1',
      start: '0',
      length: '10000'
    });

    try {
      const response = await axios.post(apiUrl, formData, {
        headers: {
          'Authorization': `Bearer ${accessToken}`,
        },
      });
      
      console.log('API Response:', response.data);

      let listData = response.data.data;

      let total = listData.reduce((acc, item) => {
        return acc + parseFloat(item.order_amount);
      }, 0);

      setGrossTotal(total);
      setNewSales(response.data.data);
    } catch (error) {
      console.error('Error fetching new sales data:', error);
    }
  };

  const handleBatchAssignementSubmit = async (e) => {
    e.preventDefault();

    const allSelectedBatchIds = Object.values(selectedBatchIds).flat();

    if (allSelectedBatchIds.length > 0) {
      try {
        const formData = new FormData();
        formData.append("batchId[]", allSelectedBatchIds.join(","));
        formData.append("orderId", orderId);

        const response = await fetch(`${config.api_url}/ws-batch-allocation`, {
          method: "POST",
          body: formData,
        });

        const data = await response.json();

        Swal.close();

        if (data.success) {
          Swal.fire({
            title: "Success!",
            text: `Allocated ${allSelectedBatchIds.length} batches successfully.`,
            icon: "success",
            timer: 2000,
            showConfirmButton: false,
          });
          fetchData();
        } else {
          Swal.fire({
            title: "Failed!",
            text: data.message || "Some batches could not be allocated.",
            icon: "error",
            timer: 3000,
            showConfirmButton: false,
          });
        }
      } catch (error) {
        Swal.close();
        console.error("Error allocating batches:", error);
        Swal.fire({
          title: "Error!",
          text: "Something went wrong while allocating batches.",
          icon: "error",
          timer: 3000,
          showConfirmButton: false,
        });
      }
    } else {
      Swal.fire({
        title: "Failed!",
        text: "Please select at least one batch before submitting.",
        icon: "error",
        timer: 1500,
        showConfirmButton: false,
      });
    }
  };



  useEffect(() => {
    if (!accessToken) {
      window.location.href = '/login';
      return;
    }
    fetchCustomerData(setCustomerData);
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fromDate, toDate, searchValue, accessToken]);

  // Removed problematic DataTable initialization that was referencing non-existent modals
  // The actual table is rendered with JSX below and has proper event handlers

  const handleDateChange = (dates) => {
    if (dates && dates.length === 2) {
      const [start, end] = dates;
      setFromDate(format(start, 'yyyy-MM-dd'));
      setToDate(format(end, 'yyyy-MM-dd'));
    } else if (!dates) {
      // Handle clearing the dates
      setFromDate('');
      setToDate('');
    }
  };

  const handleChangeBatchInfo = async (id) => {
    try {
      setOrderId(id);
      const formData = new FormData();
      formData.set('sale_id', id);

      const response = await axios.post(
        `${config.api_url}/ws-batch-info-from-sales-id`,
        formData,
        {
          headers: {
            'Authorization': `Bearer ${accessToken}`,
            'Content-Type': 'multipart/form-data',
          },
        }
      );

      const data = response.data;

      // Clear previous selections
      setSelectedBatchIds({});
      setGroupedBatches({});
      setProductBatch(data.batch);

    } catch (error) {
      console.error("Error fetching product batch data:", error);
    }
  };

  const GetProductSO = async (productId) => {
    try {
      const formData = new FormData();
      formData.set('product_id', productId);

      const response = await axios.post(
        `${config.api_url}/ws-get-product-so`,
        formData,
        {
          headers: {
            'Authorization': `Bearer ${accessToken}`,
            'Content-Type': 'multipart/form-data',
          },
        }
      );

      setProductSO(response.data.sales || []);
    } catch (error) {
      console.error("Error fetching product SO data:", error);
    }
  };

  const handleShowInvoiceModal = (productId, productDesc, productCode) => {
    setPastInvoiceHeader({ product_desc: productDesc || '', code: productCode || '' });
    GetProductSO(productId);
  };

  const ChangeCustomerSubmit = async () => {
    const form = document.getElementById('customerChangeForm');
    const formData = new FormData(form);
    formData.append('order_id', orderId);
    // let customerID = formData.get('customer_id');

    try {
      const response = await axios.post(`${config.api_url}/ws-change-customer`, formData, {
        headers: {
          authorization: `Bearer ${accessToken}`,
        }
      });

      if (response.data.success) {
        Swal.fire({
          title: "Success!",
          text: "Customer updated successfully.",
          icon: "success",
          timer: 1500,
          showConfirmButton: false,
        })
        fetchData();
      }

      if (changeCustomerModalRef.current) {
        const bsModal = window.bootstrap.Modal.getInstance(changeCustomerModalRef.current);
        if (bsModal) bsModal.hide();
      }
    } catch (error) {
      console.error("Error updating customer:", error);
    }
  }

  // Email popup functions
  const handleEmailPopupClick = async (orderId) => {
    setSelectedOrderId(orderId);
    setShowEmailPopup(true);

    // Fetch system users
    try {
      const usersResponse = await fetchUsers(1, 0, 1000);
      if (usersResponse && usersResponse.user) {
        const userOptions = usersResponse.user.map(user => ({
          value: user.email, // store email as the value for direct use
          label: `${user.name} (${user.email})`,
        }));
        setSystemUsers(userOptions);
      }
    } catch (error) {
      console.error("Failed to fetch users:", error);
      Swal.fire({
        title: "Error!",
        text: "Failed to fetch system users.",
        icon: "error",
      });
    }
  }

  const handleSendEmail = async () => {
    if (selectedUsers.length === 0) {
      Swal.fire({
        title: "Warning!",
        text: "Please select at least one user to send email.",
        icon: "warning",
      });
      return;
    }

    // Create email list and generate PDF blob attachment
    const recipientEmails = selectedUsers.map(user => user.value).join(',');
    const pdfResult = await generateProformaPDFBlob(selectedOrderId);
    // console.log(pdfResult);
    // return;
    if (!pdfResult) {
      Swal.fire({ title: 'Error!', text: 'Failed to generate PDF for attachment.', icon: 'error' });
      return;
    }

    const formData = new FormData();
    formData.append('order_id', selectedOrderId);
    formData.append('email', recipientEmails); // backend expects 'email'
    formData.append('subject', emailSubject || 'Proforma Invoice');
    formData.append('message', 'Please find attached the proforma invoice.');
    formData.append('send_copy', true);
    formData.append('attachment_type', 'proforma');
    formData.append('attachment', pdfResult.blob, pdfResult.filename);

    try {
      const response = await axios.post(`${config.api_url}/ws-send-performa-email`, formData, {
        headers: {
          'Authorization': `Bearer ${accessToken}`
        },
      });

      if (response.data.status === 'success') {
        Swal.fire({
          title: "Success!",
          text: "Email sent successfully.",
          icon: "success",
          timer: 1500,
          showConfirmButton: false,
        });
        setShowEmailPopup(false);
        setSelectedUsers([]);
        setEmailSubject('');
      } else {
        Swal.fire({
          title: "Error!",
          text: response.data.message || "Failed to send email.",
          icon: "error",
          customClass: {
            popup: 'swal2-popup-high-z'
          },
          allowOutsideClick: false,
          allowEscapeKey: false
        });
      }
    } catch (error) {
      console.error("Failed to send email:", error);
      Swal.fire({
        title: "Error!",
        text: "Failed to send email. Please try again.",
        icon: "error",
        customClass: {
          popup: 'swal2-popup-high-z'
        },
        allowOutsideClick: false,
        allowEscapeKey: false
      });
    }
  }

  // Group batches by product_id
  /*const groupedBatches = productBatch.reduce((acc, item) => {
    if (!acc[item.product_id]) {
      acc[item.product_id] = [];
    }
    acc[item.product_id].push(item);
    return acc;
  }, {});*/

  useEffect(() => {

    const groupedBatches = productBatch.reduce((acc, item) => {
      if (!acc[item.code]) {
        acc[item.code] = [];
      }
      acc[item.code].push(item);
      return acc;
    }, {});

    setGroupedBatches(groupedBatches);
  }, [productBatch]);

  return (
    <div>
      <style>
        {`
          .swal2-popup-high-z {
            z-index: 99999 !important;
          }
          .swal2-container {
            z-index: 99999 !important;
          }
          .email-modal {
            z-index: 1050 !important;
          }
          .email-modal-backdrop {
            z-index: 1040 !important;
          }
        `}
      </style>
      <div className="modal fade" id="createinvoive" tabIndex="-1" ref={createInvoiceModalRef}>
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Confirm Invoice</h5>
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div className="modal-body">
              <div className="add-product-popup">
                {createInvoiceData.map((invoice, index) => (
                  <form key={index}>
                    <div className="row mb-3 padd-l-13px">
                      <label htmlFor="desc" className="col-sm-3 col-form-label">Order ID</label>
                      <div className="col-sm-9">{invoice.reference_no}</div>
                    </div>
                    <div className="row mb-3 padd-l-13px">
                      <label htmlFor="desc" className="col-sm-3 col-form-label">Customer Name</label>
                      <div className="col-sm-9">{invoice.customer_name}</div>
                    </div>
                    <div className="purchaseftr">
                      <div className="row padd-l-13px">
                        <div className="col-6 col-lg-4 col-sm-4">Gross Value : {invoice.gross_value}</div>
                        <div className="col-6 col-lg-4 col-sm-4">Gross Profit : {invoice.gross_profit}</div>
                        <div className="col-6 col-lg-4 col-sm-4">Gross Profit % : {invoice.gross_profit_percent} %</div>
                      </div>
                    </div>
                    <div className="row mb-3 padd-l-13px">
                      <label htmlFor="desc" className="col-sm-3 col-form-label">Notes</label>
                      <div className="col-sm-9">
                        <textarea className="form-control" name="create_invoice_notes" id="create_invoice_notes" onChange={(e) => setNotes(e.target.value)}></textarea>
                      </div>
                    </div>
                    <hr />
                    <div className="form-group">
                      <a href="#" data-bs-dismiss="modal" aria-label="Close" onClick={(e) => submitCreateInvoice(invoice.id, notes, newSales, setNewSales)} className="popup-innerbtn-common">Create Invoice</a>
                    </div>
                  </form>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="modal fade" id="isSalesDeleteMdl" tabIndex="-1" ref={isSalesDeleteModalRef}>
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Are you sure to delete this S.O ?</h5>
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div className="modal-body">
              <div className="add-product-popup">
                {salesInfoData.map((sales, index) => (
                  <form key={index}>

                    <div className="row mb-3 padd-l-13px">
                      <label htmlFor="desc" className="col-sm-3 col-form-label">Enter Reason</label>
                      <div className="col-sm-9">


                        <textarea
                          className="form-control"
                          name="deleteso_notes"
                          id="deleteso_notes"
                          onChange={(e) => setNotes(e.target.value)}
                          value={notes} // Make sure to control the value with state
                        >
                          {sales.note}
                        </textarea>
                      </div>
                    </div>
                    <hr />
                    <div className="form-group">
                      <a href="#" data-bs-dismiss="modal" aria-label="Close" onClick={(e) => submitDeleteSO(sales.id, notes)} className="popup-innerbtn-common">Delete S.O</a>
                    </div>
                  </form>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="modal fade" id="change_customer" tabIndex="-1" ref={changeCustomerModalRef}>
        <div className="modal-dialog modal-md">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Change Customer</h5>
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div className="modal-body">
              <div className="add-product-popup">
                <form id="customerChangeForm">
                  <div className="row mb-3 padd-l-13px">
                    <label htmlFor="desc" className="col-sm-4 col-form-label">Select Customer</label>
                    <div className="col-sm-6">
                      <Select
                        isClearable
                        name="customer_id"
                        options={customerData}
                        placeholder="Select Customer"
                      />
                    </div>
                  </div>
                  <div className="row mb-3 padd-l-13px">
                    <label htmlFor="emailSubject" className="col-sm-3 col-form-label">Email Subject</label>
                    <div className="col-sm-9">
                      <input
                        type="text"
                        className="form-control"
                        id="emailSubject"
                        value={emailSubject}
                        onChange={(e) => setEmailSubject(e.target.value)}
                        placeholder="Proforma Invoice"
                      />
                    </div>
                  </div>
                  <div className="row mb-3 padd-l-13px">
                    <div className="col-sm-9 offset-sm-3">
                      <div className="form-check">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          id="sendCopy"
                          defaultChecked
                          disabled
                        />
                        <label className="form-check-label" htmlFor="sendCopy">
                          Send copy to proforma invoice
                        </label>
                      </div>
                    </div>
                  </div>
                  <hr />
                  <div className="form-group">
                    <a href="#" className="popup-innerbtn-common" onClick={ChangeCustomerSubmit}>Update Customer</a>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>

      // Replace the existing modal content with checkboxes
      <div className="modal fade" id="partial-popup" tabIndex="-1">
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">All Batches</h5>
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div className="modal-body">
              {Object.entries(groupedBatches).map(([batchCode, batches]) => (
                <div key={batchCode} className="partialbox">
                  <h5 className="modal-title">{batches[0]?.product_desc} ({batchCode})</h5>
                  <h3>
                    <a
                      href="#"
                      data-bs-toggle="modal"
                      data-bs-target="#vw-pst-ordr-current"
                      onClick={(e) => {
                        e.preventDefault();
                        handleShowInvoiceModal(batches[0]?.product_id, batches[0]?.product_desc, batches[0]?.code);
                      }}
                    >
                      View Past Invoices
                    </a>
                  </h3>
                  <div className="verical-scrl-wrapper partialbox-table-wrapper" id="style-3">
                    <table className="table table-bordered dataTable">
                      <thead>
                        <tr>
                          <th>Select</th>
                          <th>P.O. Qty</th>
                          <th>Sold Qty</th>
                          <th>Bal Qty</th>
                          <th>Alloc</th>
                          <th>UnAlloc</th>
                          <th>PO No.</th>
                          <th>Net Price</th>
                          <th>Received</th>
                        </tr>
                      </thead>
                      <tbody>
                        {batches.map((item) => (
                          <tr key={item.id}>
                            <td>
                              <input
                                type="checkbox"
                                id={`batch_${item.id}`}
                                value={item.id}
                                checked={selectedBatchIds[batchCode]?.includes(item.id) || false}
                                onChange={(e) => handleBatchChange(e, batchCode, item.id)}
                              />
                            </td>
                            <td>{item.qty}</td>
                            <td>{item.sale_qty}</td>
                            <td>{item.qty - item.sale_qty}</td>
                            <td>{item.allocation}</td>
                            <td>{item.qty - item.allocation}</td>
                            <td>
                              <a href={`/editNewPurchaseOrder/${item.purchase_id}`} target="_blank">
                                {item.reference_no}
                              </a>
                            </td>
                            <td>{Number(item.net_price || 0).toFixed(2)}</td>
                            <td>{item.received_quantity ?? 0}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              ))}
              <a
                data-bs-dismiss="modal"
                aria-label="Close"
                className="popup-innerbtn-common"
                onClick={handleBatchAssignementSubmit}
                style={{ marginTop: '10px' }}
              >
                Submit
              </a>
            </div>
          </div>
        </div>
      </div>

      <div className="modal fade" id="vw-pst-ordr-current" tabIndex="-1">
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">&nbsp;All Invoices of Product : {pastInvoiceHeader.product_desc} ({pastInvoiceHeader.code})</h5>
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div className="modal-body">
              <div className="partialbox">
                <table className="table table-bordered dataTable">
                  <thead>
                    <tr>
                      <th>SO#</th>
                      <th>Qty</th>
                      <th>Price </th>
                      <th>Delivered on</th>
                    </tr>
                  </thead>
                  <tbody>
                    {productSO && productSO.map((item, index) => (
                      <tr key={index}>
                        <td>{item.reference_no}</td>
                        <td>{item.quantity}</td>
                        <td>{item.price}</td>
                        <td>{item.delivery_date}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Email Popup Modal */}
      {showEmailPopup && (
        <>
          <div className="modal-backdrop fade show email-modal-backdrop"></div>
          <div className="modal fade show email-modal" style={{ display: 'block' }} tabIndex="-1" ref={emailModalRef}>
            <div className="modal-dialog modal-lg">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">Send Proforma Invoice Email</h5>
                  <button
                    type="button"
                    className="btn-close"
                    onClick={() => setShowEmailPopup(false)}
                    aria-label="Close"
                  ></button>
                </div>
                <div className="modal-body">
                  <div className="add-product-popup">
                    <form>
                      <div className="row mb-3 padd-l-13px">
                        <label htmlFor="emailUsers" className="col-sm-3 col-form-label">Select Users</label>
                        <div className="col-sm-9">
                          <Select
                            isMulti
                            isClearable
                            name="emailUsers"
                            options={systemUsers}
                            placeholder="Select users to send email"
                            value={selectedUsers}
                            onChange={setSelectedUsers}
                          />
                        </div>
                      </div>
                      <div className="row mb-3 padd-l-13px">
                        <label htmlFor="emailSubject" className="col-sm-3 col-form-label">Email Subject</label>
                        <div className="col-sm-9">
                          <input
                            type="text"
                            className="form-control"
                            id="emailSubject"
                            value={emailSubject}
                            onChange={(e) => setEmailSubject(e.target.value)}
                            placeholder="Proforma Invoice"
                          />
                        </div>
                      </div>
                      <div className="row mb-3 padd-l-13px">
                        <div className="col-sm-9 offset-sm-3">
                          <div className="form-check">
                            <input
                              className="form-check-input"
                              type="checkbox"
                              id="sendCopy"
                              defaultChecked
                              disabled
                            />
                            <label className="form-check-label" htmlFor="sendCopy">
                              Send copy to proforma invoice
                            </label>
                          </div>
                        </div>
                      </div>
                      <hr />
                      <div className="form-group">
                        <button
                          type="button"
                          className="popup-innerbtn-common"
                          onClick={handleSendEmail}
                        >
                          Send Email
                        </button>
                        <button
                          type="button"
                          className="btn btn-secondary ms-2"
                          onClick={() => setShowEmailPopup(false)}
                        >
                          Cancel
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      )}

      <Header />
      <ViewCustomer />
      <div className="breadcrumbs">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12 col-lg-12 col-sm-12">
              <a href="#"><i className="fa fa-home"></i></a> &gt;
              <a href="/Management_Dashboard">Dashboard</a> &gt;
              <span className="last-crumb">Current Sales Order</span>
            </div>
          </div>
        </div>
      </div>

      <div className="main-container">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12 col-lg-12 col-sm-12">
              <div className="dashboard">
                <div className="dashform">
                  <div className="topsearch-area">
                    <div className="row">
                      <div className="col-12 col-lg-6 col-sm-6">
                        <div className="row">
                          <label
                            htmlFor="inputText"
                            className="col-sm-4 col-form-label"
                          >
                            Search OrderID/Customer
                          </label>
                          <div className="col-sm-6">
                            <input
                              type="text"
                              className="search-area"
                              placeholder="Search"
                              autoComplete="off"
                              value={searchValue}
                              onChange={(e) => setSearchValue(e.target.value)}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-12 col-lg-4 col-sm-4">
                        <div className="row">

                          <div className="col-sm-8">
                            <DateRangePicker
                              value={[fromDate ? new Date(fromDate) : undefined, toDate ? new Date(toDate) : undefined]}
                              onChange={handleDateChange}
                              format="dd/MM/yyyy"
                              editable={false}
                              placeholder="DD/MM/YYYY - DD/MM/YYYY"
                              cleanable={true}
                              size="md"
                              style={{ width: '100%' }}
                              onClean={() => {
                                setFromDate('');
                                setToDate('');
                              }}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="verical-scrl-wrapper current-so-table" id="style-3">
                  <table className="table table-bordered dataTable" id="neworderTable1">
                    <thead>
                      <tr>
                        <th>Order Date</th>
                        <th>Exp. Del.</th>
                        <th>Order ID</th>
                        <th>Customers</th>
                        <th>Order Amount</th>
                        <th>Previous Dues</th>
                        <th>Total Dues</th>
                        <th>P.O</th>
                        <th>Status</th>
                        <th>Action</th>
                        <th>Transport</th>
                      </tr>
                    </thead>
                    <tbody>
                      {newSales.map((item, index) => (
                        <tr key={index}>
                          <td>{item.order_date}</td>
                          <td>{item.delivery_date}</td>
                          <td>
                            <a href={`/NewSalesOrderEdit/${item.ids}`}>{item.reference_no}</a>
                          </td>
                          <td>
                            <a
                              className="viewbtn"
                              href="#"
                              data-id={item.cid}
                              data-bs-toggle="modal"
                              data-bs-target="#view_customer"
                              title="View Customer"
                            >
                              {item.company_name}
                            </a>
                          </td>
                          <td style={{ textAlign: 'right' }}>{item.order_amount}</td>
                          <td>{item.previous_due}</td>
                          <td>{item.total_due}</td>
                          <td>
                            {item.bstatus !== "Mapped" ? (
                              item.status === "PF" ? (
                                <span>{item.bstatus}</span>
                              ) : (
                                <a
                                  href="#"
                                  data-bs-toggle="modal"
                                  data-bs-target="#partial-popup"
                                  onClick={() => handleChangeBatchInfo(item.ids)}
                                >
                                  {item.bstatus}
                                </a>
                              )
                            ) : (
                              <span>{item.bstatus}</span>
                            )}
                          </td>
                          <td>{item.status}</td>
                          <td>
                            <div className="btn-group">
                              <button
                                type="button"
                                className="action-btn-dd dropdown-toggle"
                                data-bs-toggle="dropdown"
                                aria-expanded="false"
                              >
                                Action
                              </button>
                              <ul className="dropdown-menu dropdown-menu-arrow">
                                {item.status === 'PF' && (
                                  <>
                                    <li>
                                      <a
                                        className="applybtn update-customer"
                                        onClick={(e) => handleGeneratePDF(e, item.ids)}
                                      >
                                        Download PF
                                      </a>
                                    </li>
                                    <li>
                                      <a
                                        className="applybtn update-customer"
                                        href="#"
                                        onClick={(e) => {
                                          e.preventDefault();
                                          handleEmailPopupClick(item.ids);
                                        }}
                                      >
                                        Email PF
                                      </a>
                                    </li>
                                    <li>
                                      <a className="applybtn update-customer" href="#" onClick={(e) => { convertToSO(item.ids, 'NA', newSales, setNewSales) }} >
                                        Convert to S.O
                                      </a>
                                    </li>
                                  </>
                                )}
                                {item.status === 'SO' && (
                                  <>
                                    {
                                      item.bstatus === "Mapped" ? (
                                        <li>
                                          <a
                                            className="deductionbtn reject-btn"
                                            href="#"
                                            onClick={() => createInvoiceClick(item.ids, newSales, setCreateInvoiceData, createInvoiceModalRef)}
                                            data-bs-toggle="modal"
                                            data-bs-target="#createinvoive"
                                          >
                                            Create Invoice
                                          </a>
                                        </li>
                                      ) : ''
                                    }
                                    <li>
                                      <a
                                        className="applybtn update-customer"
                                        onClick={(e) => handlegenerateDeliveryNotePDF(e, item.ids)}
                                      >
                                        Download Delivery Note
                                      </a>
                                    </li>
                                    {(item.bstatus === "Unmapped" || item.bstatus === "Partial") && (
                                      <li>
                                        <a className="applybtn update-customer" href={`/CreatePO/${item.ids}`}>Create a P.O</a>
                                      </li>
                                    )}

                                    <li>
                                      <a
                                        className="applybtn update-customer"
                                        href="#"
                                        onClick={(e) => {
                                          e.preventDefault();
                                          handleGenerateCollectionNotePDF(e, item.ids);
                                        }}
                                      >
                                        Collection Note
                                      </a>
                                    </li>
                                  </>
                                )}
                                <li>

                                  <a
                                    className="deductionbtn reject-btn"
                                    href="#"
                                    onClick={() => isSalesDeleteClick(item.ids, newSales, setNotes, setSalesInfoData)}
                                    data-bs-toggle="modal"
                                    data-bs-target="#isSalesDeleteMdl"
                                  >
                                    Delete Order
                                  </a>
                                </li>
                              </ul>
                            </div>
                          </td>
                          <td>
                            <label className="checkbox">
                              <input
                                type="checkbox"
                                checked={item.is_transport === 1}
                                onChange={(e) => handleTransportChange(item.ids, e.target.checked)}
                              />
                              <span className="default"></span>
                            </label>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
                <div className="purchaseftr">
                  <div className="row">
                    <div className="col-6 col-lg-3 col-sm-3">Gross Total : {grossTotal.toFixed(2)}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Footer />
        </div>
      </div>
    </div>

  );
};

export default CurrentSalesOrder;
